<template>
  <div class="c-workbench-header">
    <header class="c-workbench-header__header">
      <div class="c-workbench-header__header__main">
        <img class="c-workbench-header__logo" src="~@/assets/images/workbench/logo.png" @click="goHome" />
        <div class="c-workbench-header__right">
          <user-info
            :name="userInfo.entName"
            :icon="companyIcon"
            button-text="切换企业"
            @clickBtn="changeCompany"
          />
          <a-button
            v-if="isShowAuthBtn"
            class="p-unverified__btn"
            :loading="gotoAuthBtnLoading"
            @click="gotoAuthPage"
          >
            未认证
          </a-button>
          <div class="c-workbench-header-bell">
            <a-dropdown v-model="visible">
              <a-badge :count="unreadCount" @click="gotoStationPage">
                <a-icon type="bell" />
              </a-badge>
              <div slot="overlay" class="c-workbench-header-bell__wrap">
                <div class="c-workbench-header-bell__wrap__tabs">
                  <div class="c-workbench-header-bell__wrap__tabs__item" :class="stationType === 'task' ? 'c-workbench-header-bell__wrap__tabs__item--active' : ''" @click="changeStationType('task')">
                    待办事项
                    <a-badge v-if="unTaskCount" :count="unTaskCount" />
                  </div>
                  <div class="c-workbench-header-bell__wrap__tabs__item" :class="stationType === 'notice' ? 'c-workbench-header-bell__wrap__tabs__item--active' : ''" @click="changeStationType('notice')">
                    消息通知
                    <a-badge v-if="unMessageCount" :count="unMessageCount" />
                  </div>
                </div>
                <div class="c-workbench-header-bell__wrap__content">
                  <div v-if="stationList.length !== 0" class="c-workbench-header-bell__wrap__content__list">
                    <div
                      v-for="item in stationList"
                      :key="item.id"
                      class="c-workbench-header-bell__wrap__content__item"
                    >
                      <div class="c-workbench-header-bell__wrap__content__left">
                        <div class="c-workbench-header-bell__wrap__content__item__title">
                          {{ item.title }}
                        </div>
                      </div>
                      <template v-if="stationType === 'notice'">
                        <a-button
                          style="padding: 0"
                          type="link"
                          title="标记为已读"
                          @click="readNews(item)"
                        >
                          <svg
                            t="1692166932890"
                            class="icon"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="16695"
                            width="26"
                            height="26"
                          ><path d="M859.5 290c9.7-0.5 19.1 2.9 26.3 9.4 13.6 12.3 15.8 32.5 5.9 47.3l-3.3 4.3-335.2 371c-8.8 9.7-22 14-34.8 11.2-3.1-0.7-6.1-1.7-8.8-3.1l-7.2-4.2-3.1-2.2-169.9-133.4c-16-12.6-18.8-35.9-6.2-51.9 11.5-14.6 31.7-18.2 47.4-9.3l4.5 3.1L522 647.5 834.2 302c5.2-5.7 12.1-9.7 19.5-11.2l5.8-0.8zM176.1 526.7l5.4 2.5 4.5 3.1 146.9 115.3 0.2-0.2 57.8 45.1-26.8 29.5c-8.8 9.7-22 14-34.8 11.2-3.1-0.7-6.1-1.7-8.8-3.1l-7.2-4.2-3.1-2.2-170-133.4c-16-12.6-18.8-35.9-6.2-51.9 10.3-12.9 27.4-17.2 42.1-11.7zM670.4 290c9.7-0.5 19.1 2.9 26.3 9.4 13.6 12.3 15.8 32.5 5.9 47.3l-3.3 4.3L494 578.1 436.3 533l208.8-231c5.2-5.7 12.1-9.7 19.5-11.2l5.8-0.8z" p-id="16696" fill="#257EFE" /></svg>
                        </a-button>
                      </template>
                      <template v-if="item.buttonList && item.buttonList[0]">
                        <div class="c-workbench-header-bell__wrap__content__item__right" :title="item.buttonList[0].name" @click="clickBellItem(item)">
                          {{ item.buttonList[0].name }}
                        </div>
                      </template>
                    </div>
                  </div>
                  <div v-else class="c-workbench-header-bell__wrap__empty">
                    <div>{{ stationEmptyText }}</div>
                  </div>
                </div>
                <div class="c-workbench-header-bell__wrap__botttom">
                  <template v-if="stationType === 'task'">
                    <div class="c-workbench-header-bell__wrap__botttom__btn" @click="gotoStationPage">查看全部</div>
                  </template>
                  <template v-else>
                    <div class="c-workbench-header-bell__wrap__botttom__btn" :class="stationList.length == 0 ? 'c-workbench-header-bell__wrap__botttom__btn--disable' : ''" @click="stationAllReadHandler">全部标为已读</div>
                    <div class="c-workbench-header-bell__wrap__botttom__btn" @click="gotoStationPage">查看全部</div>
                  </template>
                </div>
              </div>
            </a-dropdown>
          </div>
          <user-info
            :name="userInfo.name"
            :icon="peopleIcon"
            :buttons="btns"
            @clickItem="clickItem"
          />
        </div>
      </div>
    </header>
    <a-modal
      v-model="ifShowCompany"
      title="切换企业"
      ok-text="确定"
      cancel-text="取消"
      :centered="true"
      :confirm-loading="confirmLoading"
      @ok="clickCompany"
    >
      <a-radio-group v-model="currentEntId" class="c-common-header__select__company">
        <a-radio v-for="(item) in companyList" :key="item.entId" :value="item.entId">
          {{ item.entName }}
        </a-radio>
      </a-radio-group>
    </a-modal>
    <!-- <PasswordModal ref="passwordModal" @submit="changePass" /> -->
  </div>
</template>
<script>
import UserInfo from '@/components/user-info.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    UserInfo,
  },
  props: {
    goToPersonalCenter: {
      type: Function,
      default: null
    },
  },
  data() {
    return {
      companyIcon: require('@/assets/images/workbench/ent.svg'),
      peopleIcon: require('@/assets/images/workbench/avatar.svg'),
      userInfo: { entUserName: '', entName: '' },
      btns: [{ text: '个人中心', key: 'goToPersonalCenter' }, { text: '退出登录', key: 'logout' }],
      currentEntId: 0,
      companyList: [],
      ifShowCompany: false,
      stationList: [],
      stationType: 'task',
      visible: false,
      unreadCount: 0,
      unMessageCount: 0,
      unTaskCount: 0,
      unreadCountTimer: null,
      isShowAuthBtn: false,
      gotoAuthBtnLoading: false,
      hiddenProperty: '',
      confirmLoading: false,
      stationSummaryResult: {}
    }
  },
  computed: {
    stationEmptyText() {
      if (this.stationType === 'task') {
        return '暂无未完成的待办事项'
      } else {
        return '暂无新的消息通知'
      }
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.getStationStatusData()
      }
    }
  },
  async created() {
    await this.getUserInfo()
    await this.getCompanyListData()
    this.getStationStatusData()
    this.getCheckEntAuthStatus()
    this.hiddenProperty = 'hidden' in document ? 'hidden' :
      'webkitHidden' in document ? 'webkitHidden' :
        'mozHidden' in document ? 'mozHidden' : null
    const visibilityChangeEvent = this.hiddenProperty.replace(/hidden/i, 'visibilitychange')
    document.addEventListener(visibilityChangeEvent, this.onVisibilityChange)
  },
  beforeDestroy() {
    if (this.unreadCountTimer) {
      clearTimeout(this.unreadCountTimer)
      this.unreadCountTimer = null
    }
    const visibilityChangeEvent = this.hiddenProperty.replace(/hidden/i, 'visibilitychange')
    document.removeEventListener(visibilityChangeEvent, this.onVisibilityChange)
  },
  methods: {
    ...mapActions('system-monitoring', ['monitoringEnt', 'isLive']),
    ...mapActions('station', ['getStationStatus', 'searchStationSummaryList', 'stationTaskGo', 'stationAllRead', 'stationRead']),
    ...mapActions('user-info', [
      'getAppInfoByCode',
      'getCompanyInfo',
      'getCompanyList',
      'selectCompany',
      'checkEntAuth',
      'getAuthLink',
      'logOut',
    ]),
    onVisibilityChange() {
      if (!document[this.hiddenProperty]) {
        this.getStationStatusData()
      } else {
        if (this.unreadCountTimer) {
          clearTimeout(this.unreadCountTimer)
          this.unreadCountTimer = null
        }
      }
    },
    async readNews(row) {
      await this.stationRead([row.messageId])
      this.$message.success('成功标记为已读')
      this.getStationStatusData(true)
    },
    async getStationStatusData(stayNotice) {
      if (this.unreadCountTimer) {
        clearTimeout(this.unreadCountTimer)
        this.unreadCountTimer = null
      }
      const result = await this.getStationStatus() || {}
      this.unTaskCount = result.task || 0
      this.unMessageCount = result.notice || 0
      this.unreadCount = this.unTaskCount + this.unMessageCount
      if (!stayNotice) {
        if (this.unTaskCount === 0) {
          this.stationType = 'notice'
        } else {
          this.stationType = 'task'
        }
      }
      this.getStationList()
      this.unreadCountTimer = setTimeout(() => {
        this.getStationStatusData()
      }, 60000)
    },
    async getStationList() {
      this.stationSummaryResult = await this.searchStationSummaryList() || {}
      if (this.stationType === 'task') {
        this.stationList = this.stationSummaryResult.taskList || []
      } else {
        this.stationList = this.stationSummaryResult.noticeList || []
      }
    },
    changeStationType(type) {
      this.stationType = type
      if (this.stationType === 'task') {
        this.stationList = this.stationSummaryResult.taskList || []
      } else {
        this.stationList = this.stationSummaryResult.noticeList || []
      }
    },
    async stationAllReadHandler() {
      if (this.stationList.length === 0) {
        return
      }
      await this.stationAllRead()
      this.$message.success('成功标记所有未读消息为已读')
      this.getStationStatusData(true)
    },
    async clickBellItem(item) {
      this.stationTaskGo({
        bId: item.buttonList[0].id,
        mId: item.messageId
      })
    },
    checkNotice(item) {
      this.goToPersonalCenter(`/personal-center/message.html?type=${this.stationType}&id=${item.messageId}`)
    },
    gotoStationPage() {
      this.goToPersonalCenter(`/personal-center/message.html?type=${this.stationType}`)
    },
    goHome() {
      this.$router.replace('/workbench')
    },
    clickItem(item) {
      const method = item.key
      if (typeof this[method] === 'function') this[method]()
    },
    toMine() {
      this.$router.push({
        path: '/mine'
      })
    },
    async logout() {
      try {
        await this.logOut()
      } catch (error) {
      }
      localStorage.removeItem('token')
      sessionStorage.removeItem('sessionId')
      this.$router.replace('/')
    },
    async getUserInfo() {
      const userInfo = await this.getCompanyInfo() || {}
      this.userInfo = userInfo.user
      this.currentEntId = userInfo.entId
      await this.$store.dispatch('product/getAppInfo')
    },
    async getCompanyListData() {
      const res = await this.getCompanyList()
      this.companyList = res || []
      const currentEnt = this.companyList.find(i => i.entId === this.currentEntId)
      this.userInfo.entName = currentEnt.entName
    },
    changeCompany() {
      this.currentEntId = this.userInfo.entId
      this.ifShowCompany = true
    },
    async clickCompany() {
      try {
        this.confirmLoading = true
        await this.selectCompany({ entId: this.currentEntId })
        try {
          await this.monitoringEnt({ entId: this.currentEntId })
          this.isLive()
        } catch {}
        this.ifShowCompany = false
        this.isShowAuthBtn = false
        await this.getUserInfo()
        await this.getCompanyListData()
        this.$message.success('企业切换成功')
        this.getStationStatusData()
        this.getCheckEntAuthStatus()
        this.$emit('refresh-list')
      } catch (error) {
      }
      this.confirmLoading = false
    },
    async getCheckEntAuthStatus() {
      const result = await this.checkEntAuth()
      if (result && result.admin && result.status !== 2) {
        this.isShowAuthBtn = true
      }
    },
    async gotoAuthPage() {
      try {
        this.gotoAuthBtnLoading = true
        const res = await this.getAuthLink()
        window.open(res)
      } catch (e) {
        if (e.code === 1450006) {
          this.isShowAuthBtn = false
        }
      }
      this.gotoAuthBtnLoading = false
    }
  }
}
</script>

<style lang="scss">
.c-workbench-header {
  .c-workbench-header__header {
    position: relative;
    width: 100%;
    height: 0.64rem;
    background: #fff;
    z-index: 1;
  }
  .c-workbench-header__header__main {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.4rem;
  margin: auto;
  position: relative;
  }
  .c-workbench-header__logo {
    width: 1.68rem;
    height: 0.32rem;
    vertical-align: middle;
    cursor: pointer;
  }
  .p-my-product__phone {
    color: #555;
  }
  .p-my-product__phone::after {
    display: none;
  }
  .p-my-product__ent-icon {
    display: block;
  }
  .c-workbench-header__right {
    display: flex;
    align-items: center;
    .p-unverified__btn {
      margin-left: 20px;
      height: 28px;
      line-height: 26px;
      font-weight: 400;
      font-style: normal;
      font-size: 14px;
      color: #F56C6C;
      border: 1px solid rgb(247, 137, 137);
      background-color: rgb(254, 240, 240);
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
    }
    .p-unverified__btn.ant-btn-loading {
      opacity: 0.8;
    }
    .p-unverified__btn.ant-btn::before {
      background: transparent;
    }
  }
  .c-workbench-header-bell {
    color: #555;
    margin-right: 24px;
    margin-left: 32px;
    .anticon-bell {
      font-size: 20px;
      cursor: pointer;
    }
    .ant-badge-count {
      right: -4px;
      padding: 0px 4px;
      height: 16px;
      line-height: 16px;
      cursor: pointer;
    }
  }
}
.c-common-header__select__company {
  text-align: left;
  width: 100%;
  overflow-y: auto;
  max-height: 300px;
  padding-left: 20px;
  .ant-radio-wrapper {
    display: block;
  }
  .ant-radio-wrapper+.ant-radio-wrapper {
    margin-top: 6px;
  }
}
.c-workbench-header-bell__wrap {
  width: 330px;
  background-color: #fff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0 , 0.2);
  .c-workbench-header-bell__wrap__tabs {
    display: flex;
    border-bottom: 1px solid rgb(215, 215, 215);
  }
  .c-workbench-header-bell__wrap__tabs__item {
    position: relative;
    flex: 1;
    line-height: 44px;
    text-align: center;
    cursor: pointer;
  }
  .c-workbench-header-bell__wrap__tabs__item--active {
    color: rgb(24, 144, 255);
  }
  .c-workbench-header-bell__wrap__tabs__item--active::after {
    content: "";
    display: block;
    background-color: rgb(24, 144, 255);
    width: 100%;
    height: 2px;
  }
  .c-workbench-header-bell__wrap__content {
    padding: 16px;
    max-height: 400px;
    overflow-y: auto;
  }
  .c-workbench-header-bell__wrap__content::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
  }
  .c-workbench-header-bell__wrap__content::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background: #999;
  }
  .c-workbench-header-bell__wrap__content::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    background-color: #fff;
  }
  .c-workbench-header-bell__wrap__content__item {
    display: flex;
    .c-workbench-header-bell__wrap__content__left {
      flex: 1;
      display: flex;
      align-items: center;
      overflow: hidden;
    }
    .c-workbench-header-bell__wrap__content__item__right {
      margin-left: 10px;
      min-width: 60px;
      max-width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      border: 1px solid rgb(24, 144, 255);
      height: 24px;
      font-size: 14px;
      color: rgb(24, 144, 255);
      line-height: 24px;
      border-radius: 4px;
      text-align: center;
      cursor: pointer;
      white-space: nowrap;
      padding: 0 4px;
    }
    .c-workbench-header-bell__wrap__content__item__right:hover, .c-workbench-header-bell__wrap__content__item__right:focus, .c-workbench-header-bell__wrap__content__item__right:active {
      color: #409eff;
      background: #ecf5ff;
      border-color: #b3d8ff;
    }
  }
  .c-workbench-header-bell__wrap__content__item+.c-workbench-header-bell__wrap__content__item {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid rgb(215, 215, 215);
  }
  .c-workbench-header-bell__wrap__empty {
    text-align: center;
  }
  .c-workbench-header-bell__wrap__botttom {
    display: flex;
    border-top: 1px solid rgb(215, 215, 215);
    .c-workbench-header-bell__wrap__botttom__btn {
      height: 46px;
      line-height: 46px;
      text-align: center;
      flex: 1;
      cursor: pointer;
    }
    .c-workbench-header-bell__wrap__botttom__btn+.c-workbench-header-bell__wrap__botttom__btn {
      border-left: 1px solid rgb(215, 215, 215);
    }
    .c-workbench-header-bell__wrap__botttom__btn:hover {
      color: #40a9ff;
    }
    .c-workbench-header-bell__wrap__botttom__btn--disable {
      color: rgb(170, 170, 170) !important;
      cursor: no-drop;
    }
  }
}

</style>
